
import styled from  "styled-components";


export const theme ={
    bgColor:"#010306",
    dashBg:"#E9EDF8",
    textColor:"#f4f6f5",
    accentColor:"0,59,115",
    accentColor01:"31,59,113",
    accentColor02:"241,220,124",
    accentColor03:"96,131,92",
    itemColor1:"0,151,151",
    itemColor2:"0,115,181",
    itemColor3:"77,94,154",
    opacity: 0.05,
    opacity1: 10,
    opacity2: 0.2,
    opacity4: 0.4,

    //** radius */
    column5:"0.3125rem",
    column10:"0.625rem",
    column15:"0.9375rem",
    column20:"1.25rem",
    column25:"1.5625rem",
    column30:"1.875rem",
    column40:"2.5rem",
}

//Container는 App()에 포함됨
export const Container = styled.div`
    position: relative;
    margin: 0;
    width: 100%;
    height: 100vh;
    padding: 0;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
   /* overflow: auto; */

`

//Container = styled.div`가 Navbar에  감싸고 있다.

const marginTop= '4rem;'; // Navbar 높이만큼 margin-top 줌
const marginTopHeight= '4.5rem'; // Navbar 높이만큼 margin-top 줌

export const Section = styled.div`
    margin: 0 auto;
    /* margin-top: ${marginTop}; */
    height: calc(100dvh - 4rem); 
    position: relative;

    /* width: 100vw; */
    width: 100%;
    max-width: 80rem;
    padding: 0 4px;
    /* border: 1px solid #4e0101ff; */
  /* margin-top: -1rem; */
`;


export const Section_90 = styled.div`
    margin: 0 auto;
    height: calc(100dvh - 4rem); 
    position: relative;
    width: 100%;
    max-width: 90rem;
    padding: 0 4px;
`;


export const Section_100 = styled.div`
    margin: 0 auto;
    height: calc(100dvh - 4rem); 
    position: relative;
    width: 100%;
    max-width: 100rem;
    padding: 0 4px;
`;



export const Section2 = styled.div`
    margin-top: ${marginTop};
    height: calc(100dvh - ${marginTopHeight}); 
    position: relative;
    padding: 0;
    width: 100%;
    /* margin: 0 auto; //이거 하면 안됨 상단위로 올라감 */
    padding: 0 4px;
`;

export const Section100 = styled.div`
    /* margin: 0 auto;
    margin-top: 3.9rem;
    height: calc(100dvh - ${marginTopHeight}); 
    position: relative;
    padding: 0;
    width: 100vw;
    max-width: 100rem; */

     margin: 0 auto;
    margin-top: ${marginTop};
    height: calc(100dvh - ${marginTopHeight}); 
    position: relative;

    /* width: 100vw; */
    width: 100%;
    max-width: 100rem;
    padding: 0 4px;
`;



export const Section60 = styled.div`
    margin: 0 auto;
    margin-top: 3.9rem;
    height: calc(100dvh - 4.5rem); 
    position: relative;
    padding: 0;
    width: 100vw;
    max-width: 60rem;
  
`;


export const Section_frame = styled.div`
    margin: 0 auto;
    margin-top: 3.9rem;
    height: calc(100dvh - 4.5rem); 
    /* position: relative; 이거하면 하위 Section에서 모달 안됨 */
    padding: 0;
    /* width: 100vw; */
    overflow-y: auto;
    width: 100%;
    /* border: 1px solid red !important; */
`;

export const Section_frame_overFlow = styled.div`
    margin: 0 auto;
    margin-top: 3.9rem;
    height: calc(100dvh - 4.5rem); 
    /* position: relative; 이거하면 하위 Section에서 모달 안됨 */
    padding: 0;
    /* width: 100vw; */
    overflow-y: auto;
    overflow-x: auto;
    width: 100%;
    /* border: 1px solid red !important; */
    padding: 4px;
`;


export const Section_scroll = styled.div`
    margin: 0 auto;
    padding: 0;
    width: 100%;
    max-width: 80rem;   

`;


export const Section_border = styled.div`
    margin: 0 auto;
    margin-top: 3.9rem;
    height: calc(100dvh - 4.5rem); 
    position: relative;
    padding: 0;
    width: 100vw;
    max-width: 80rem;
    border: 1px solid #ddd;
`;


export const Section_border_small = styled.div`
    margin: 0 auto;
    margin-top: 3.9rem;
    height: calc(100dvh - 4.5rem); 
    position: relative;
    padding: 0;
    width: 100vw;
    max-width: 60rem;
    border: 1px solid #ddd;
`;




export const Section90 = styled.div`
    margin: 0 auto;
    margin-top: 3.9rem;
    height: calc(100dvh - 4.5rem); 
    position: relative;
    padding: 0;
    width: 100vw;
    max-width: 90rem;
`;




export const Section_wide = styled.div`
    margin-top: 3.7rem;
    height: calc(100dvh - 3.7rem); 
    position: relative;
    padding: 0;
    width: 100vw;
    width: 100%;
    overflow-y: auto;
`;


export const Section_n = styled.div`
    display: flex;
    flex-direction: column;
    height: 100dvh;
    position: relative;
    padding: 0;
    width: 100vw;
    max-width: 80rem;
    overflow: hidden;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    text-align: center;
    margin: 0 auto; /* 수평 가운데 정렬 */
`;


export const Section_n_small = styled.div`
    display: flex;
    flex-direction: column;
    height: 100dvh;
    position: relative;
    padding: 0;
    width: 100vw;
    max-width: 60rem;
    overflow: hidden;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    text-align: center;
    margin: 0 auto; /* 수평 가운데 정렬 */
`;


export const Modal = styled.div`
    position:absolute;
    top: 0rem;
    left: 0px;
    width: 100%;//스크롤 생기면 부모가 왼쪽으로 이동한다.
    height: calc(100dvh - 7.0rem); 
    z-index: 10000;
    background-color: white;
    
`;


// export const Modal_pc = styled.div`
//     position:absolute;
//     top: 0rem;
//     left: 0px;
//     width: 100%;//스크롤 생기면 부모가 왼쪽으로 이동한다.
//     /* height: calc(100dvh - 5.0rem);  */
//     height: calc(100dvh - 4.0rem); 
//     z-index: 10000;
//     background-color: white;   
//     /* border: 1px solid #ddd; */
    
// `;



export const Modal_pc = styled.div`
    position:absolute;
    top: 0rem;
    left: 0px;
    width: 100%;//스크롤 생기면 부모가 왼쪽으로 이동한다.
    /* height: calc(100dvh - 5.0rem);  */
    height: calc(100dvh - ${props => (props.$hasNav ?? true ? '4rem' : '0rem')});
    z-index: 10000;
    background-color: white;   
    padding: ${props => props.$padding ?? '0rem'};
       /* padding: 0.5rem; */
       /* border: 1px solid blue; */
`;


// export const Modal_pc_fullHeight = styled.div`
//     position:absolute;
//     top: 0rem;
//     left: 0px;
//     width: 100%;//스크롤 생기면 부모가 왼쪽으로 이동한다.
//     /* height: calc(100dvh - 5.0rem);  */
//     height: calc(100dvh - 0.0rem); 
//     z-index: 10000;
//     background-color: white;   
//     border: 1px solid #ddd;
    
    
// `;
// JS(.js)에서 사용
export const Modal_pc_fullHeight = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100;
  height: calc(100dvh - ${props => (props.$hasNav ? '4rem' : '0rem')});
  z-index: 10000;
  background-color: white;
  /* border: 1px solid #ddd; */
  box-sizing: border-box;
    /* border: 1px solid #12d168ff !important; */
`;



export const Modal_pc_fixed = styled.div`
    position:fixed;
    top: 0rem;
    left: 0px;
    width: 100%;//스크롤 생기면 부모가 왼쪽으로 이동한다.
    /* height: calc(100dvh - 5.0rem);  */
    height: calc(100dvh - 0.0rem); 
    z-index: 10000;
    background-color: white;   
    border: 1px solid #ddd;
 
    
`;


export const Modal2 = styled.div`
    position:absolute;
    top: 0rem;
    left: 0px;
    width: 100%;//스크롤 생기면 부모가 왼쪽으로 이동한다.
    height: calc(100dvh - 7.0rem); 
    z-index: 0;
    background-color: white;
    overflow-x: hidden;
    overflow-y: hidden;
`;


export const Modal3 = styled.div`
    position:absolute;
    top: 0rem;
    left: 0px;
    width: 100%;//스크롤 생기면 부모가 왼쪽으로 이동한다.
    height: calc(100dvh - 7.0rem); 
    z-index: 10;
    background-color: white;
    
`;



export const Modal_fullScreen = styled.div`
    position:fixed;
    top: 0rem;
    left: 0px;
    width: 100%;//스크롤 생기면 부모가 왼쪽으로 이동한다.
    height: calc(100dvh - 0rem); 
    z-index: 10;
    background-color: ${(props) => props.$backgroundColor || 'rgba(1, 1, 1, 0.1)'};
    display:flex;
    justify-content:center;
    /* props 사용법 */
   /* <S.Modal_fullScreen $backgroundColor='white'> */
    
`;





export const SubVisual = styled.div`
    position: relative;
    margin: 0 auto;
    height: max(450px, 2vh, 450px);
    >div{
        max-width: 98.75rem;
        padding: 0 2rem;
        margin:0 auto;
        display: flex;
        align-items: center;
        height:100%;
        h1{

            color:white;
            font-weight: 800;
            font-size: 3.75rem;
            text-align: left;
        }
    }
`


// export default theme